import { get } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default Route.extend({
  abilities: service(),
  fundsService: service(),
  router: service(),
  storeCache: service(),

  beforeModel(transition) {
    if (this.abilities.noAbility('admin_edit_users')) {
      transition.abort();
      return;
    }
    return this.fundsService.confirmValidFundToken();
  },

  model(params) {
    return this.storeCache
      .indexSingleBy('admin/user', 'id')
      .then((usersById) => {
        return {
          record: get(usersById, params.id),
        };
      });
  },

  afterModel(model) {
    if (isEmpty(model.record)) {
      this.router.transitionTo('admin.users.not-found');
    }
  },
});
